import { useMemo } from "react";
import {
  createBrowserRouter,
  IndexRouteObject,
  NonIndexRouteObject,
  RouteObject,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import { AvisRoute } from "../../../data/avisRoutes";
import { NavigateUser } from "./NavigateUser";

interface IProps {
  children: JSX.Element | JSX.Element[];
  routes?: AvisRoute[];
}

function mapRoutes(routes?: AvisRoute[]): RouteObject[] | undefined {
  if (!routes?.length) return undefined;

  return routes.map((route) => {
    let result: RouteObject;

    if (route.index) {
      result = {
        index: route.index,
        id: route.key,
        key: route.key ?? route.path,
        path: route.path,
        element: route.element,
        children: mapRoutes(route.children) as any,
      } as IndexRouteObject;
    } else {
      result = {
        index: route.index,
        id: route.key,
        key: route.key ?? route.path,
        path: route.path,
        element: route.element,
        children: mapRoutes(route.children) as any,
      } as NonIndexRouteObject;
    }

    return result;
  });
}

export default function AvisRouterHoc(props: Readonly<IProps>): JSX.Element {
  const { children, routes } = props;
  const mappedRoutes = useMemo(() => mapRoutes(routes), [routes]);

  const BubbleError = () => {
    const error = useRouteError();
    throw error;
  };

  const router = useMemo(
    () =>
      createBrowserRouter([
        {
          id: "home",
          path: "/",
          element: children,
          children: mappedRoutes,
          errorElement: <BubbleError />,
        },
        {
          id: "unknown",
          path: "*",
          element: <NavigateUser />,
        },
      ]),
    [children, mappedRoutes],
  );

  return <RouterProvider router={router} />;
}
